export default __webpack_public_path__ + "static/media/maorPartners.2005cd80.jpg";